import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_ITEMS = [
  { id: "o-mne", label: "O mne" },
  { id: "co-robim", label: "Čo robím" },
  { id: "projekty", label: "Projekty" },
  { id: "skusenosti", label: "Skúsenosti" },
  { id: "nastroje", label: "Nástroje" },
  { id: "kontakt", label: "Kontakt" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/55 border-b border-white/[0.06]"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12 h-16 lg:h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
        >
          <span className="relative w-9 h-9 rounded-lg bg-[#C6F432] flex items-center justify-center font-black text-[#0A0A0A] text-lg shadow-[0_0_24px_rgba(198,244,50,0.35)] group-hover:rotate-6 transition-transform">
            PV
          </span>
          <span className="hidden sm:block">
            <div className="text-[13px] leading-none font-semibold tracking-tight">
              Peter Vaško
            </div>
            <div className="text-[11px] leading-none mt-1 text-white/50 uppercase tracking-[0.18em]">
              Full-Stack Marketer
            </div>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-1 bg-white/[0.03] border border-white/[0.06] rounded-full p-1.5">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-link-${item.id}`}
              onClick={() => go(item.id)}
              className="px-4 py-1.5 text-[13px] text-white/70 hover:text-white rounded-full hover:bg-white/[0.05] transition-colors"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="cta-nav-contact"
          onClick={() => go("kontakt")}
          className="hidden lg:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#C6F432] text-[#0A0A0A] text-[13px] font-semibold hover:bg-white transition-colors btn-shine"
        >
          Napíšte mi
          <span className="w-1.5 h-1.5 rounded-full bg-[#0A0A0A]"></span>
        </button>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 rounded-md text-white/80 hover:text-white"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden border-t border-white/[0.06] bg-black/85 backdrop-blur-xl">
          <div className="px-6 py-4 flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                data-testid={`nav-mobile-link-${item.id}`}
                onClick={() => go(item.id)}
                className="text-left py-3 text-base text-white/80 hover:text-[#C6F432] border-b border-white/5"
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
